import type { FlightSearchPagedResultData } from "@/features/flights/hooks/flightSearch/types";
import type {
  FullOfferType,
  MappedFlightOffer,
} from "@/features/flights/types/types";
import type { PackageBannerV3 } from "@/types/codegen";

export const isPackageBanner = (
  offer: FullOfferType,
): offer is PackageBannerV3 => {
  return offer.type === "PACKAGE_BANNER";
};

export const isFlightOffer = (
  offer: FullOfferType,
): offer is MappedFlightOffer => {
  return offer.type === "FLIGHT_OFFER";
};

export const getOfferByIdFromSearchResult = (
  response: FlightSearchPagedResultData,
  offerId: string | null,
) => {
  const offers = response.pages.flatMap((page) => page.offers);
  const selectedOffer = offers.find(
    (offer): offer is MappedFlightOffer =>
      isFlightOffer(offer) && offer.index === offerId,
  );
  return selectedOffer;
};
